import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ApiService } from "./api.service";
import { CommonService } from "./common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { appRenameFixed } from "./appRenameFixed";
import { AbilityConfig } from "./ability-config/ability-config";


declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-learning-path-new',
  templateUrl: './learning-path-new.component.html',
  styleUrls: ['./learning-path-new.component.css',]
})
export class LearningPathNewComponent implements OnInit, AfterViewInit {

	mode: number;
	sub: any;
	user: any;
	learningPathMetaId:number;
	learningPath: any;
	currentIndexMode2: number;
	status: number;
	learningTour:boolean;
	appRename:appRenameFixed = new appRenameFixed();
	tryout: boolean;
	mengban: boolean;
	companyUrl:string = "";
	companyLogo:string = "";
	//配置信息
	abilityConfig:AbilityConfig;
  abilityBack: boolean;
  isShowTip: boolean = false;
  isShowQuestionnaire: boolean = false;
  questionnaireInfo: any = null;
  assetsRoute: string = "../../assets";
  desText: any = '由于升级系统，你需要重新完成<font color="#FFE258">能力诊断</font>，原本学习的数据已被<font color="#FFE258">保留</font>。';
  constructor(private apiService: ApiService,
                private commonService: CommonService,
                private route: ActivatedRoute,
                private router: Router) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.isShowBackBtn();
  	this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);
    window.sessionStorage.removeItem('newEdition');
    // this.getThirdCompany();
    this.mengban = false;
    this.sub = this.route.params.subscribe(params => {
      this.learningPathMetaId = params['learningPathMetaId'];
    });
    //开始记录各能力学习时长
    // localStorage.setItem("learningPathMetaId",this.learningPathMetaId + "");
    // localStorage.setItem("learningPathMetaId-moduleId","-1");
    this.apiService.ajax({
      'type':'GET',
      'url':'/sr/exposeoutapi/setAbilitySession/'+this.learningPathMetaId+'/-1'
    }).subscribe(result=>{});


    this.getOrCreateLearningPath(this.learningPathMetaId).then(result=>{
      this.learningPath = result;
      this.companyUrl =  this.learningPath.burl? this.learningPath.burl: "";
      this.mode = this.learningPath.subItems.length > 3 ? 1 : 2;
    }).then(()=>{
      return this.getUserQuestionnaireInfo(this.learningPathMetaId).then(result=>{
        return this.questionnaireInfo = result;
      })
    }).then(()=>{
      return this.getUserStatus().then(result=>{
        return this.status = result;
      });
    }).then(()=>{
      return this.getUserInfo().then(result=> {
        return this.user = result;
      });
    }).then(()=>{
      //满意度调查显示逻辑
      //获取到用户相应能力满意度 （questionnaireInfo长度为0 || questionnaireInfo长度大于0 && isShow不等于1） &&情景模拟完成了 && 后测没有完成
      this.isShowQuestionnaire = this.questionnaireInfo && (this.questionnaireInfo.length ===0 || (this.questionnaireInfo.length > 0 && this.questionnaireInfo.filter(d=>d.star === -1).length > 0)) && this.learningPath.subItems[this.getModuleIndex(4)].progress !==100 && this.learningPath.subItems[this.getModuleIndex(3)].progress ===100 ? true : false;
      // this.isShowQuestionnaire = true;
      console.log(this.isShowQuestionnaire);
      // 无后测版本逻辑
      // 是2019年6月18日以前注册的用户并且能力诊断未完成并且是之前完成过改课程的用户显示提示框
      this.isShowTip = this.compareDate("2019-06-18", this.user.createdAt.split('T')[0]) && this.learningPath.subItems[this.getModuleIndex(1)].progress !==100 && this.learningPath.subItems[this.getModuleIndex(2)].progress > 0 ? true : false;
    });
  }


  //查询用户相应能力满意度
  getUserQuestionnaireInfo(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
    }).toPromise();
  }

  //获取模块位于learningPathSubItem里的下标
  getModuleIndex(value){
    return this.learningPath.subItems.map(item => item.type).indexOf(value);
  }

  // 根据learningPathMetaId创建或者获取LearningPath
  getOrCreateLearningPath(learningPathMetaId){
    return this.apiService.getOrCreateLearningPath(learningPathMetaId.toString()).toPromise();
  }

  //获取用户Status
  getUserStatus(){
    return this.apiService.ajax({
      'type': 'post',
      'url': '/api/getUserInfo',
      'data': {}
    }).toPromise();
  }

  //获取用户信息
  getUserInfo(){
    return this.apiService.getUserInfo().toPromise();
  }


  // 比较日期大小
  compareDate(d1, d2){
    let constDate = new Date(d1);
    let date = new Date(d2);
    return constDate.getTime() > date.getTime() ? true : false;
  }

  // 关闭问卷
  closeQuestionnaire(){
    this.isShowQuestionnaire = false;
  }




  /* 获取第三方公司返回 */
  isShowBackBtn(){
  	this.apiService.ajax({
	    'type':'GET',
	    'url': 'sr/exposeoutapi/getAbilityBack'
	  }).subscribe(result=>{
      this.abilityBack = result.data.abilityBack;
	  });
  }

  ngAfterViewInit(){
    this.commonService.initPage();
  }

  goToLearningMap(){
  	if(this.companyUrl ){
  	  if(this.companyUrl=="#"){
  	    return false;
      }else{
        location.href = this.companyUrl;
      }
  	}else{
      let link = ['learning-map'];
      this.router.navigate(link);
    }
  }

  hideTip(){
      $("#shade").fadeOut();
      $('#tip').fadeOut();
  }

    hideTip2(){
        $("#shade2").fadeOut();
        $('#tip2').fadeOut();
    }

    try() {
        let link = ['form', '3'];
        this.router.navigate(link);
    }
    mban() {
      if(this.status!=1){
          console.log("点击");
          this.mengban = false;
      }
    }
    shiyong() {
      this.mengban = false;
      let link = ['form', '3'];
      this.router.navigate(link);
    }
    closeTip() {
      this.mengban = false;
    }

    cardClick(i){
      let type = this.learningPath.subItems[i].type;
      //开始记录各能力模块学习时长
    	// localStorage.setItem("learningPathMetaId-moduleId",type + "");
      this.apiService.ajax({
        'type':'GET',
        'url':'/sr/exposeoutapi/setAbilitySession/'+this.learningPathMetaId+'/'+type
      }).subscribe(result=>{});

      if(type==0){
          this.showVector();
      }else if(type==1){
          this.showPreSurvey();
      }else if(type==2){
          this.showCourse();
      }else if(type==3){
          this.showPractice();
      }else if(type==4){
          this.showPostSurvey();
      }
    }


  showVector(){
    if(this.status== 4||this.status==3){
      let link = ['vector', this.learningPath.id];
      this.router.navigate(link);
    }else if(this.learningPath.currentItemIndex>=0&&this.status==1){
      let link = ['vector', this.learningPath.id];
      this.router.navigate(link);
      }
  }

    showPreSurvey() {
      let surveyMetaId,
          itemIndex;
      /* 进入新能力诊断标识 */
    	let version = 0;

      this.learningPath.subItems.forEach(function (item,index){
        if(item.type==1){
          surveyMetaId = item.surveyMetaId;
          itemIndex = index;
          if(item.version){
          	version = item.version;
          }
        }
      });

      // if(this.learningPath.currentItemIndex>=itemIndex&&this.status==1){
      if(this.learningPath.currentItemIndex>=itemIndex&&this.status==1 || (this.status ==4||this.status==3)){
        if (this.learningPath.status == 0) {
          this.apiService.updateLearningPathStatus(this.learningPath.id).subscribe(result => {
          });
        }

        let link = ['survey', this.learningPath.id, surveyMetaId, 1];
        //影响力转向新能力检测
        if(version == 1){
        	link = ['ability-survey', this.learningPathMetaId, 1];
        }
        this.router.navigate(link);
      }else if(this.learningPath.currentItemIndex<itemIndex&&this.status==1){
        $("#toast1").fadeIn(500,function () {
          setTimeout(function () {
            $("#toast1").fadeOut(800);
          },800);
        });
      }
    }

    showCourse() {
        let courseId,
            itemIndex;
        this.learningPath.subItems.forEach(function (item,index) {
            if(item.type==2){
                courseId = item.id;
                itemIndex = index;
            }
        });

        if(this.status == 3 || this.status ==4){
          let link = ['course', this.learningPath.id, courseId];
          this.router.navigate(link);
        }else{
          if(this.learningPath.currentItemIndex>=itemIndex||this.status!=1){
            let link = ['course', this.learningPath.id, courseId];
            this.router.navigate(link);
          }else if(this.learningPath.currentItemIndex<itemIndex&&this.status==1){
            $("#toast1").fadeIn(500,function () {
              setTimeout(function () {
                $("#toast1").fadeOut(800);
              },800);
            });
          }
        }

    }

    showPractice() {
      let practiceMetaId,
          practiceIndex;
      this.learningPath.subItems.forEach(function (item,index) {
          if(item.type==3){
             practiceMetaId = item.practiceMetaId;
             practiceIndex = index;
          }
      });

      if(this.learningPath.currentItemIndex>=practiceIndex||this.status!=1){
					//转向情景列表
					let link = this.abilityConfig.getPracticeLinkList(this.learningPath.name,this.learningPath.id,practiceMetaId);
					if(link.length > 0){
						this.router.navigate(link);
					}

        }else if(this.learningPath.currentItemIndex<practiceIndex&&this.status==1){
          $("#toast1").fadeIn(500,function () {
            setTimeout(function () {
              $("#toast1").fadeOut(800);
            },800);
          });
        }
    }

    showPostSurvey() {
      let surveyMetaId,
          itemIndex;
      /* 进入新能力诊断标识 */
    	let version = 0;
      this.learningPath.subItems.forEach(function (item,index) {
        if(item.type==4){
          surveyMetaId = item.surveyMetaId;
          itemIndex = index;
          if(item.version){
          	version = item.version;
          }
        }
      });
      // console.log(this.learningPath);
      if(this.learningPath.currentItemIndex>=itemIndex&&this.status==1){
        let link = ['survey', this.learningPath.id, surveyMetaId, 1];
        //影响力转向新能力检测
        if(version == 1){
        	link = ['ability-survey', this.learningPathMetaId, 2];
        }
        this.router.navigate(link);
      }else if(this.learningPath.currentItemIndex<itemIndex&&this.status==1){
        $("#toast1").fadeIn(500,function () {
            setTimeout(function () {
                $("#toast1").fadeOut(800);
            },800);
        });
      }
    }

  exitTip(){
    this.isShowTip = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/learning-path-new.component.ts